import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { Footer, FooterProps } from '@gn-audio/jss-components';
import tailwindConfig from '@gn-audio/jss-components/tailwind-presets/jabra-preset';

import { withTheme } from 'common/jabraTheme/withTheme';
import { ComponentProps } from 'lib/component-props';

export default withTheme({
  defaultTheme: {
    darkTheme: false,
    backgroundColor: tailwindConfig.theme.colors.beige['100'],
  },
})(withDatasourceCheck()<ComponentProps & FooterProps>(Footer));
